document.addEventListener("DOMContentLoaded", () => {
    // Get real pickup-availability element & the clone target (in accordian)
    const real = document.querySelector("#pickup-availability");
    const cloneTarget = document.querySelector("#pickup-availability-accordian");
    // Clone the innerHTML from pickup-availability to the accordian
    function syncPickup() {
        if (real && cloneTarget) {
        cloneTarget.innerHTML = real.innerHTML;
        }
    }
    // Clone when DOMcontentLoaded
    syncPickup();
    // Re-clone whenever Shopify updates pickup availability
    const observer = new MutationObserver(syncPickup);
    observer.observe(real, { childList: true, subtree: true });
});